import React, { useEffect, createElement } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { RecipeSuggester } from './components/RecipeSuggester';
import { RecipeOfTheDay } from './components/RecipeOfTheDay';
import { RecipeCategories } from './components/RecipeCategories';
import { YouTubeSection } from './components/YouTubeSection';
import { RecipeGenerator } from './components/RecipeGenerator';
import { Footer } from './components/Footer';
export function App() {
  // Dynamically set favicon to BeVegToday logo
  useEffect(() => {
    const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || (() => {
      const el = document.createElement('link');
      el.rel = 'icon';
      document.head.appendChild(el);
      return el;
    })();
    link.href = 'https://cdn.magicpatterns.com/uploads/2pSPbYAXJgMUjkWB2iejxz/bevegtoday.png';
    link.type = 'image/png';
    document.title = 'BeVegToday — Vegetarian Recipes';
  }, []);
  return <div className="min-h-screen bg-[#fffbf5]" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <section id="home" data-id="element-3">
          <Hero data-id="element-4" />
        </section>
        <section id="recipe-of-day" data-id="element-5">
          <RecipeOfTheDay data-id="element-6" />
        </section>
        <section id="finder" data-id="element-7">
          <RecipeSuggester data-id="element-8" />
        </section>
        <section id="generator" data-id="element-9">
          <RecipeGenerator data-id="element-10" />
        </section>
        <section id="categories" data-id="element-11">
          <RecipeCategories data-id="element-12" />
        </section>
        <section id="videos" data-id="element-13">
          <YouTubeSection data-id="element-14" />
        </section>
      </main>
      <Footer data-id="element-15" />
    </div>;
}